module.exports = __webpack_public_path__ + "img/metamask-custom-token.20b8fbb2.png";